import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yellowtime",
  "use": "icon-yellowtime-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yellowtime\">\n<circle cx=\"7\" cy=\"7\" r=\"5.625\" stroke=\"#FAAD14\" />\n<path d=\"M7.21655 3.09373L7.21655 6.99918L4.94671 9.13101\" stroke=\"#FAAD14\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol